//import environment from '../../env/env';
import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetChallenges = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challenges/get`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
export const GetChallengeById = async (id) => {
    var config = {
        method: 'get',
        url: configData.API_ENDPOINT + `challenges/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateChallenge = async (v, id) => {
    var config = {
        method: 'put',
        url: configData.API_ENDPOINT + `challenges/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const CreateChallenge = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challenges`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const DeleteChallenge = async (id) => {
    var config = {
        method: 'delete',
        url: configData.API_ENDPOINT + `challenges/${id}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        // data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

    export const handleDownload = async (filename) => {
        var config = {
            method: 'get',
            url: configData.API_ENDPOINT + `challenges/download/${filename}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
    .then(response => {
        const url = response.data.data;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
    .catch(error => {
        // Handle download error
    });
    };

// Without Authentication

export const GetBusinessChallenges = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challenges/getchallenges`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetAllStudentDetail = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/getallchallenge`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetStudentDetail = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `StudentChallenge/getchallenge`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const getpdfUploadLink = async (challengeId, fileName) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `Challenges/upload/${challengeId}/${fileName}`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const uploadPdf = async (uploadUrl, pdfData) => {
    var config = {
        method: 'put',
        url: uploadUrl,
        headers: {
            'Content-Type': 'application/pdf',
        },
        data: pdfData
    };
    return axios(config)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}
